import type { MetaReducer } from '@ngrx/store';
import type { TypedAction } from '../actions';
import type { StoreState } from '../store.model';

export function storeClearReducerFactory(): MetaReducer<
  StoreState,
  TypedAction
> {
  return reducer => (state, action) => {
    if (action.type === 'CLEAR_STORE') {
      return reducer({}, action);
    }
    return reducer(state, action);
  };
}
